import { EventBus } from 'primevue/utils';

var DynamicDialogEventBus = EventBus();

export { DynamicDialogEventBus as default };
